import { useEffect, useState, useRef } from 'react';
import FloatingShapes from './FloatingShapes';
import SlideArtwork from './SlideArtwork';
import Icon from './Icon';
import { SYSTEM_URL } from '../constants';
import styles from './Slide.module.css';

export default function Slide({ slide, active }) {
  const [visible, setVisible] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => {
    if (active) {
      setVisible(false);
      timerRef.current = setTimeout(() => setVisible(true), 80);
    } else {
      setVisible(false);
    }
    return () => clearTimeout(timerRef.current);
  }, [active, slide.id]);

  return (
    <div
      className={styles.slide}
      style={{
        background: slide.bg,
        opacity: active ? 1 : 0,
        pointerEvents: active ? 'auto' : 'none',
      }}
    >
      {/* Capa 1: formas geométricas de fondo */}
      <FloatingShapes shapes={slide.shapes} />

      {/* Capa 2: figuras de moda animadas estilo GTA */}
      <SlideArtwork artworks={slide.artworks || []} active={active} />

      {/* Capa 3: contenido de texto (encima de todo) */}
      <div className={styles.content}>
        <div
          className={styles.eyebrow}
          style={{
            borderColor: slide.accent,
            color: slide.accent,
            opacity: visible ? 1 : 0,
            transform: visible ? 'translateY(0)' : 'translateY(16px)',
            transitionDelay: '0.05s',
          }}
        >
          {slide.eyebrow}
        </div>

        <h1
          className={styles.title}
          style={{
            opacity: visible ? 1 : 0,
            transform: visible ? 'translateY(0)' : 'translateY(22px)',
            transitionDelay: '0.15s',
          }}
        >
          {slide.title}
        </h1>

        <p
          className={styles.desc}
          style={{
            opacity: visible ? 1 : 0,
            transform: visible ? 'translateY(0)' : 'translateY(18px)',
            transitionDelay: '0.27s',
          }}
        >
          {slide.subtitle}
        </p>

        <a
          href={SYSTEM_URL}
          className={styles.cta}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            background: slide.wrods,
            boxShadow: `0 8px 28px ${slide.accent}44`,
            opacity: visible ? 1 : 0,
            transform: visible ? 'translateY(0) scale(1)' : 'translateY(16px) scale(0.97)',
            transitionDelay: '0.4s',
          }}
        >
          {slide.cta}
          <Icon name="arrowRight" size={16} color="#fff" />
        </a>
      </div>

      <span
        className={styles.tag}
        style={{ opacity: visible ? 1 : 0, transitionDelay: '0.55s' }}
      >
        {slide.tag}
      </span>
    </div>
  );
}
